import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9ff71ca8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=9ff71ca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff71ca8",
  null
  
)

export default component.exports